<template>
    <b-modal :visible="visible" no-close-on-backdrop no-close-on-esc centered>
        <div slot="modal-header" class="w-100">
            <h5>Select Organization
                <button type="button" class="close"
                        @click.prevent="closeModal()">
                    <span aria-hidden="true">&times;</span></button>
            </h5>
        </div>
        <div class="org-list-body">
            <div class="providers-list-select" v-for="org in organizations" :key="org.organizationId">
                <label :for="'org-picker-' + org.organizationId">
                    <input class="m-1" type="radio" :id="'org-picker-' + org.organizationId"
                           v-model="selectedOrgId" :value="org.organizationId"/>
                    {{ org.name }}
                </label>
                <br/>
            </div>
        </div>
        <div slot="modal-footer" class="w-100">
            <button type="button" class="btn btn-orange float-right" @click.prevent="selectOrganization()">Save</button>
            <button type="button" class="btn btn-outline-orange mr-2 float-right" @click.prevent="closeModal()">Close</button>
        </div>
    </b-modal>
</template>

<script>
  import api from '../services/api'

  export default {
    name: 'organization-picker',

    props: {
      visible: {
        type: Boolean,
        required: true
      }
    },

    data () {
      return {
        selectedOrgId: 0,
        organizations: []
      }
    },

    methods: {
      selectOrganization () {
        const selectedOrg = this.organizations.filter(org => {
          return org.organizationId === this.selectedOrgId
        })[0]
        this.$store.setOrganization(selectedOrg)
        this.closeModal()
      },

      closeModal () {
        this.$emit('update:visible', false)
      },

      loadOrgs () {

        if (!this.$store.isAdmin) {
          return
        }

        api.get('/Admin/Organizations').then(response => {

          this.organizations = response.data

        }).catch(error => {
          if (!this.$store.canHandleNetworkError(error)) {
            this.$log.error('Error attempting to load organizations: ' + error.message, error)
          }
        })
      },

      handleUserAuthenticated (authenticated) {
        if (authenticated) {
          this.loadOrgs()
        }
      },

      handleOrgChange (newOrg, event) {
        this.selectedOrgId = newOrg.organizationId
      }
    },

    created () {
      this.$store.$on('user:authenticated', this.handleUserAuthenticated)
      this.$store.$on('organization:changed', this.handleOrgChange)
      if (this.$store.isAuthenticated) {
        this.selectedOrgId = this.$store.organization.organizationId
        this.loadOrgs()
      }
    }
  }
</script>

<style scoped>
    .org-list-body {
        max-height: 490px;
        overflow-y: auto;
        overflow-x: hidden;
        min-width: 300px;
    }

</style>
